module.exports = __webpack_public_path__ + "static/media/thinktamil.7df52b7e.png";